import axios from 'axios'
// import VueCookies from 'vue-cookies'

const apiClient = axios.create({
  baseURL:  `${process.env.VUE_APP_API_URL}`,
  withCredentials: false,
  headers: {
    Accept: 'application/json',
    'Content-type': 'application/json'
  },
  timeout: 10000 //Throw error if API call takes longer than 10 sec//
})

apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.authorization = 'Bearer '+ token;
    }
    return config;
  },
  (error) => Promise.reject(error),
);

export default {
  // services for PRODUCT //
  getClientDetails() {
    const user = localStorage.getItem('user')
    return apiClient.get(`/clients/${JSON.parse(user).id}`) //API call that fetch all products in json object//
  },
  getClientActiveDetail() {
    return apiClient.get('/check/client/active')
  },
  addPresetcategoriesForClient(countryJson) {
    return apiClient.post('/duplicate/categories', countryJson)
  },
  fetchCascadianCityList(lang) {
    return apiClient.get(`/cascadian/city?lang=${lang}`)
  },
  fetchCascadianRegion(reqJson) {
    return apiClient.get(`/cascadian/region?lang=${reqJson.lang}&&city=${reqJson.city}`)
  },
  sendRestockRejectionMailToClient(mailBody) {
    return apiClient.post(`/restock/rejection/email`, mailBody)
  }
}
